import { render, staticRenderFns } from "./BarEChart.vue?vue&type=template&id=08d44fa0&scoped=true"
import script from "./BarEChart.vue?vue&type=script&lang=js"
export * from "./BarEChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d44fa0",
  null
  
)

export default component.exports